(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/enetpulse/views/enetpulse.js') >= 0) return;  svs.modules.push('/widgets/enetpulse/views/enetpulse.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.widget=_svs.widget||{};
_svs.widget.enetpulse=_svs.widget.enetpulse||{};
_svs.widget.enetpulse.templates=_svs.widget.enetpulse.templates||{};
svs.widget.enetpulse.templates.enetpulse = Handlebars.template({"0":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<section class=\"widget-default enetpulse-wrapper\">\n  \u003Cscript type=\"application/javascript\" src=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"scriptUrl") || (depth0 != null ? lookupProperty(depth0,"scriptUrl") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"scriptUrl","hash":{},"data":data,"loc":{"start":{"line":3,"column":45},"end":{"line":3,"column":58}}}) : helper)))
    + "\">\u003C/script>\n</section>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"currentWidget") : depth0),{"name":"with","hash":{},"fn":container.program(0, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":5,"column":9}}})) != null ? stack1 : "");
},"useData":true});
Handlebars.partials['widget-enetpulse-enetpulse'] = svs.widget.enetpulse.templates.enetpulse;
})(svs, Handlebars);


 })(window);